import { Link } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import AppLogo from "../../../components/AppLogo";
import { LmsAuthWrapper } from "../styles/LmsAuthStyle";

const LmsAuthShell = ({ title, subtitle, children }) => (
  <LmsAuthWrapper>
    <Link to="/landing" className="lms-auth-back-link" aria-label="Back to landing page">
      <FaArrowLeft aria-hidden="true" />
      <span>Back</span>
    </Link>
    <section className="lms-auth-panel" aria-label={title}>
      <div className="lms-auth-story">
        <AppLogo containerStyle="lms-logo-container" textStyle="lms-logo-text" />
        <p className="eyebrow">Learning Management System</p>
        <h1>Reading growth starts with one thoughtful challenge.</h1>
        <p>
          Teachers and parents can create learners, assign reading experiences, and watch
          progress become visible over time.
        </p>
      </div>
      <div className="lms-auth-card">
        <div className="lms-auth-heading">
          <p className="eyebrow">Welcome</p>
          <h2>{title}</h2>
          <p>{subtitle}</p>
        </div>
        {children}
      </div>
    </section>
  </LmsAuthWrapper>
);

export default LmsAuthShell;
